import React, { Children, ReactElement, useMemo } from 'react';

export interface SwitchProps<T = unknown> {
  value: T;
  children: ReactElement<CaseProps<T>> | Array<ReactElement<CaseProps<T>>>;
}
export function Switch<T>(props: SwitchProps<T>) {
  const childToRender = useMemo(() => {
    const childrenArray = Children.toArray(props.children) as ReactElement<
      CaseProps<T>
    >[];
    for (const child of childrenArray) {
      if (child.props.value === props.value) {
        return child;
      }
    }
  }, [props.children, props.value]);

  return <>{childToRender}</>;
}

export interface CaseProps<T = unknown> {
  children: React.ReactNode;
  value: T | undefined | null;
}

export function Case<T = unknown>(props: CaseProps<T>) {
  return <>{props.children}</>;
}

function Test() {
  const [value, setValue] = React.useState<'one' | 'two'>('one');
  return (
    <Switch value={value}>
      <Case value="one">
        <p>One</p>
      </Case>
      <Case value="two">two</Case>
    </Switch>
  );
}
